import CtaDefault from './ui/cta/CtaDefault'
import Icon from './svg/icon'
import clsx from 'clsx'
import { GridCardFragment } from '@/lib/types/datocms/graphql/generated'

type GridCardProps = GridCardFragment

export function GridCard({
	id,
	title,
	address,
	phone,
	email,
	cta,
	className,
}: GridCardProps & { className?: string }) {
	return (
		<div
			className={clsx('flex flex-col gap-2 bg-white rounded-lg px-4 py-8 lg:p-10', className)}
			key={id}
		>
			{title && <h3 className="text-2xl font-medium">{title}</h3>}
			{address && (
				<span className="mt-1 flex items-center gap-2">
					<Icon icon="LocationPinSimple" />
					{address}
				</span>
			)}
			{phone && (
				<p className="mt-8">
					<span className="text-blue">Phone:</span> <a href={`tel:${phone}`}>{phone}</a>
				</p>
			)}

			{email && (
				<p className="mb-4">
					<span className="text-blue">Email:</span> <a href={`mailto:${email}`}>{email}</a>
				</p>
			)}
			{cta && <CtaDefault className="w-full mt-auto" cta={cta} />}
		</div>
	)
}
